import React, { useEffect, useState, useRef, useCallback, createContext } from 'react'

import { setHome, setLoading, setReading } from './store/stageSlice';
import { useEffectOnceWhen } from "rooks"
import useWindowManager from './useWindowManager'
import { Box } from '@mui/material'
import { ReactComponent as Loader } from './svg/loader.svg';
import CustomAlert from './utils/CustomAlert';
import Konva from 'konva';
import { Stage, Layer, Image, Group } from 'react-konva'
import { gsap } from 'gsap'
import {isMobile} from "./utils/deviceUtils"

import useProtectScreen from './utils/useProtectScreen';

import DiffieHellmanAES from './security/DiffieHellmanAES'

// import {ExcelsiorCenter} from './ExcelsiorCenter'
import { ExcelsiorRect } from './config/ExcelsiorRect'
import ExcelsiorAnimationCueController from './animation/ExcelsiorAnimationCueController';
//import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { decryptFile } from './security/index.js'

import { useSelector, useDispatch } from 'react-redux';
import {
    setZoomed,
    setZoomedPosition,
    setMode,
    setCurrentPage,
    setCurrentPages,
    setNumPages,
    setCurrentPanel,
    setDoNext,
    setWorking,
    setAnimating,
    setIssueObject,
} from './store/readerSlice'

import { GetIssuePDFRef, SetIssuePDFRef, GetBookData } from './store/ExcelsiorDataContext'
//import { makeProtectedRequest } from './strapi/makeRequest'
import ArrowAlert from './components/ArrowAlert'
import BetaDisclaimer from './components/BetaDisclaimer'
import Shake from './utils/Shake'

import { setError } from './store/errorSlice';

import './Excelsior.css'


export const NavigationalContext = createContext()

function ExcelsiorPageViewerFunc() {

    //const { executeRecaptcha } = useGoogleReCaptcha();
    const dhAES = useRef(new DiffieHellmanAES());

    const publicKeyRef = useRef(null);


    //CONTEXT
    const pdfRef = GetIssuePDFRef()

    //console.log(pdfRef)
    const setPdfRef = SetIssuePDFRef()
    const bookData = GetBookData()


    //REDUX
    const dispatch = useDispatch()

    const zoomed = useSelector(state => state.reader.zoomed)
    const zoomedPosition = useSelector(state => state.reader.zoomedPosition)
    const mode = useSelector(state => state.reader.mode)
    const currentPage = useSelector(state => state.reader.currentPage)
    const currentPages = useSelector(state => state.reader.currentPages)
    const numPages = useSelector(state => state.reader.numPages)
    const issueObject = useSelector(state => state.reader.issueObject)
    const address = useSelector((state) => state.auth.address);

    const currentPanel = useSelector(state => state.reader.currentPanel)
    const working = useSelector(state => state.reader.working)
    const animating = useSelector(state => state.reader.animating)
    const currentAction = useSelector(state => state.reader.doNext)

    const ZOOM_MAX = useSelector(state => state.reader.zoomMax)
    const TRANSITION_SPEED = useSelector(state => state.reader.transitionSpeed)
    const FOCUS_ANIMATION_ENABLED = useSelector(state => state.reader.focusAnimationSwitchValue)



    const setZoomedStore = (v) => dispatch(setZoomed(v))
    const setZoomedPositionStore = (v) => dispatch(setZoomedPosition(v))
    const setModeStore = (v) => dispatch(setMode(v))
    const setCurrentPageStore = (v) => dispatch(setCurrentPage(v))
    const setCurrentPagesStore = (v) => dispatch(setCurrentPages(v))
    const setNumPagesStore = (v) => dispatch(setNumPages(v))
    const setIssueObjectStore = (v) => dispatch(setIssueObject(v))

    const setCurrentPanelStore = (v) => dispatch(setCurrentPanel(v))
    const setCurrentActionStore = (v) => dispatch(setDoNext(v))
    const setWorkingStore = (v) => dispatch(setWorking(v))
    const setAnimatingStore = (v) => dispatch(setAnimating(v))


    const {
        size,
        windowResizing,
        portrait,
        getWindowResized
    } = useWindowManager()


    const layerRef1 = useRef(null)
    const layerRef2 = useRef(null)
    const imageRef1 = useRef(null)
    const imageRef2 = useRef(null)
    const groupRef1 = useRef(null)
    const groupRef2 = useRef(null)
    const stageDivRef1 = useRef(null)
    const stageDivRef2 = useRef(null)
    // const VIEW_SCALE = window.devicePixelRatio || 1
    // const VIEW_SCALE = isMobile() ? 3 : (window.devicePixelRatio || 2);
    const VIEW_SCALE = isMobile() ? 3 : 4;

    const ZOOM_MIN = 1


    var whichCanvasLayer
    var canvasholder = []

    const animTweenRef = useRef(null)
    const animController = new ExcelsiorAnimationCueController(animTweenRef)

    const timeoutRef = useRef(null); // Reference to store the timeout
    const renderBasedOnExtensionTimeoutRef = useRef(null);


    let pdf_doc
    let pdfjsLib = useRef(null);
    let pdfjsWorker = useRef(null);
    const pdfModulesLoaded = useRef(false);
    let ComicArchiveFileProcessor = useRef(null);
    const comicArchiverModulesLoaded = useRef(false);

    var pagesRendering = [false, false] // pdf pages are currently rendering
    const loadingTask = useRef(null); //task for getting the pdf document
    var renderTasks = [null, null] //task for rendering pdf pages
    var pageViews = [null, null]

    const [layerOneZIndex, setLayerOneZIndex] = useState(5)
    const [layerTwoZIndex, setLayerTwoZIndex] = useState(6)
    const [previousPages, setPreviousPages] = useState([0, 0])
    const [previousPage, setPreviousPage] = useState(0)
    const [previousPanel, setPreviousPanel] = useState(1)
    const [previousZoomed, setPreviousZoomed] = useState(false)
    const [previousZoomMax, setPreviousZoomMax] = useState(ZOOM_MAX)
    const [previousMode, setPreviousMode] = useState('')
    const [inited, setInitied] = useState(false)
    const [currentPermaType] = useState(null);
    const lastClick = useRef(null);

    const [extension, setExtention] = useState(null)
    const lastActionRef = useRef(["", 0]);


    const [canvas1, setCanvas1] = useState([null, { w: 0, h: 0, naturalWidth: 0, naturalHeight: 0, origScale: 1, canvasScale: 1 }, Date.now()])
    const [canvas2, setCanvas2] = useState([null, { w: 0, h: 0, naturalWidth: 0, naturalHeight: 0, origScale: 1, canvasScale: 1 }, Date.now()])

    const { valueProtection, focusProtection } = useProtectScreen()

    /*

      ISSUE OBJECT

    */
    function basicIssueObjectChecks() {
        if (!issueObject) { return }
        if (!issueObject.layout) { return }
        if (!issueObject.layout.pages) { return }
        if (!issueObject.layout.pages[String("pg" + currentPage)]) { return }
        return true
    }
    const issuePanelObject = () => {
        if (!basicIssueObjectChecks()) { return }
        let pn = issuePageObject().panels[String("pn" + currentPanel)]
        if (!pn) {
            pn = issuePageObject().panels[String("pn" + 1)]
            setCurrentPanelStore(1)
        }
        return pn
    }
    const issuePageObject = () => {
        if (!basicIssueObjectChecks()) { return }
        return issueObject.layout.pages[String("pg" + currentPage)]
    }
    // const issuePageViewObject = () => {
    //     if (!basicIssueObjectChecks()) { return }
    //     return issueObject.layout.pageview
    // }
    const totalPanels = () => {
        if (!basicIssueObjectChecks()) { return }
        return issuePageObject().panels.length
    }
    const totalPanelsPreviousPage = () => {
        if (!basicIssueObjectChecks()) { return }
        if (currentPage - 1 <= 0) { return 1 }
        return issueObject.layout.pages[String("pg" + (currentPage - 1))].panels.length
    }



    /*

            MOVE

    */


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const moveToNextPanel = useCallback((skipAnim = false, doSecondaryFX = true) => {
        if (!inited) { return }
        if (!pdfRef) { return }

        setWorkingStore(true)
        setAnimatingStore(true)

        if (animTweenRef.current && animTweenRef.current.isActive()) {
            //animTweenRef.current.progress(1).kill();
            return;
        }

        var page = !portrait ? (currentPage % 2) : 0
        page = currentPage === 1 || currentPage === 0 ? 0 : currentPages[0] === numPages ? 0 : page


        var canvobj = getCurrentCanvasLayer()


        var pn = issuePanelObject()
        if (!pn) { return }
        var x = pn.x
        var y = pn.y
        var width = pn.w
        var height = pn.h

        var groupEl = getCurrentLayerGroup()

        var imageRef = getCurrentImageRef()
        //console.log(imageRef.current, whichCanvasLayer)
        if (!imageRef.current) { return }
        var imgRect = imageRef.current.getClientRect()

        if (groupEl.attrs.x) {
            //Correct for group transform
            imgRect.x -= groupEl.attrs.x
            imgRect.y -= groupEl.attrs.y
            imgRect.x /= groupEl.attrs.scaleX
            imgRect.y /= groupEl.attrs.scaleX
            imgRect.width /= groupEl.attrs.scaleX
            imgRect.height /= groupEl.attrs.scaleX
        }

        //This is how we should calculate the originalScale since origScale from viewport is incorrect
        const widthRatio = size.width / canvobj[1].naturalWidth
        const heightRatio = size.height / canvobj[1].naturalHeight
        var scale = Math.min(widthRatio, heightRatio)
        //scale = canvobj[1].origScale


        const scaleX = size.width / (width * scale)
        const scaleY = size.height / (height * scale)
        const boundingRectScale = Math.min(scaleX, scaleY)

        const boundingRectX = ((x * scale) + imgRect.x) + ((imgRect.width / 2) * page)
        const boundingRectY = (y * scale) + imgRect.y


        const newX = imgRect.x + (imgRect.width / 2) - (boundingRectX + (width / 2) * scale) * boundingRectScale
        const newY = imgRect.y + (imgRect.height / 2) - (boundingRectY + (height / 2) * scale) * boundingRectScale

        //It broke, time to reset
        if (isNaN(newX) || isNaN(newY) || isNaN(boundingRectScale) || isNaN(boundingRectX) || isNaN(boundingRectY)) {
            setModeStore('classic')
            return
        }
        Konva.showWarnings = false

        // eslint-disable-next-line react-hooks/exhaustive-deps
        animTweenRef.current = gsap.to(groupEl, {
            x: newX,
            y: newY,
            scaleX: boundingRectScale,
            scaleY: boundingRectScale,
            clipX: Math.floor(boundingRectX),
            clipY: Math.floor(boundingRectY),
            clipWidth: Math.ceil(width * scale),
            clipHeight: Math.ceil(height * scale),
            duration: skipAnim ? .00001 : TRANSITION_SPEED,
            delay: 0.01,
            onComplete: function () {
                Konva.showWarnings = true
                setWorkingStore(false)
                setAnimatingStore(false)

                if (!doSecondaryFX) { return }
                if (!FOCUS_ANIMATION_ENABLED) { return }
                if (pn.fx) {
                    switch (pn.fx) {
                        case "shake-1":
                            animController.shakeScreen(getCurrentCanvasContainer(), 1)
                            break
                        case "shake-2":
                            animController.shakeScreen(getCurrentCanvasContainer(), 2)
                            break
                        case "shake-3":
                            animController.shakeScreen(getCurrentCanvasContainer(), 3)
                            break
                        case "shake-4":
                            animController.shakeScreen(getCurrentCanvasContainer(), 4)
                            break
                        case "shake-5":
                            animController.shakeScreen(getCurrentCanvasContainer(), 5)
                            break
                        case "emphasis":
                            animController.emphasisScreen(getCurrentCanvasContainer(), imageRef.current.getClientRect(), boundingRectScale)
                            break
                        case "emphasis-2":
                            animController.emphasisScreen(getCurrentCanvasContainer(), imageRef.current.getClientRect(), boundingRectScale, 1)
                            break
                        case "stretch-horiz":
                            animController.stretchScreen(getCurrentCanvasContainer(), imageRef.current.getClientRect(), boundingRectScale)
                            break
                        case "stretch-vert":
                            animController.stretchScreen(getCurrentCanvasContainer(), imageRef.current.getClientRect(), boundingRectScale, false)
                            break
                        case "shiver":
                            animController.shiverScreen(getCurrentCanvasContainer(), imageRef.current.getClientRect(), boundingRectScale)
                            break
                        case "plop":
                            animController.plopScreen(getCurrentCanvasContainer(), imageRef.current.getClientRect(), boundingRectScale)
                            break
                        default:
                            break
                    }
                }
            }
        })


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [size, canvas1, canvas2, currentPanel, currentPage, inited, animTweenRef])



    /*
  
              ZOOM / DRAG
  
      */

    const fastResetCanvasZoom = () => {
        gsap.set([layerRef1.current, layerRef2.current], {
            scaleX: ZOOM_MIN,
            scaleY: ZOOM_MIN,
            x: 0,
            y: 0
        })


    }


    const zoomPage = () => {

        resetDraggedElements()


        gsap.to([layerRef1.current, layerRef2.current], {
            scaleX: zoomed ? ZOOM_MAX : ZOOM_MIN,
            scaleY: zoomed ? ZOOM_MAX : ZOOM_MIN,
            duration: TRANSITION_SPEED,
            ease: "easer.Inout",
            delay: 0.1,
            onComplete: () => {

            },
        })

        resetClippedGroups()

    }


    const updateCompanionLayer = (me, companion) => {
        companion.x(me.x())
        companion.y(me.y())
    }


    /*
    
    RENDERS
    
    */

    /*
    
        // DETERMINE FILE FORMAT
    
        */

    // Determine which function to use based on the file extension
    const renderBasedOnExtension = async () => {
        //
        // If publicKey is not ready, clear any existing timeouts and set a new one
        if (!publicKeyRef.current && extension === "perma") {
            if (renderBasedOnExtensionTimeoutRef.current) {
                clearTimeout(renderBasedOnExtensionTimeoutRef.current);
            }
            renderBasedOnExtensionTimeoutRef.current = setTimeout(renderBasedOnExtension, 100); // retry after 100ms
            return;
        }
        switch (extension) {
            case 'pdf':
            case '.pdf':
                if (!pdfModulesLoaded.current) {
                    try {
                        [pdfjsLib.current, pdfjsWorker.current] = await Promise.all([
                            import('pdfjs-dist/webpack'),
                            import('pdfjs-dist/build/pdf.worker.entry')
                        ]);
                        pdfjsLib.current.GlobalWorkerOptions.workerSrc = pdfjsWorker.current;
                        pdfjsLib.current.isOffscreenCanvasSupported = false;
                        pdfModulesLoaded.current = true;
                    } catch (error) {
                        console.error('Error loading PDF modules:', error);
                    }
                }

                renderPDFPages(currentPages);

                break
            case 'cbz':
            case '.cbz':
            case 'cbr':
            case '.cbr':
            case 'cbt':
            case '.cbt':
                if (!comicArchiverModulesLoaded.current) {
                    let ComicArchiveFileProcessorModule = await import('./utils/ComicArchiveFileProcessor');
                    ComicArchiveFileProcessor.current = ComicArchiveFileProcessorModule.default.init();
                    comicArchiverModulesLoaded.current = true;
                }

                renderComicFiles(currentPages)
                break
            case 'perma':
                setNumPagesStore(issueObject.layout.pages.length)
                if (bookData[5] === "preview") {
                    //Load in preview
                    let o = {}
                    o["id"] = issueObject.id;
                    o["publickey"] = publicKeyRef.current;
                    //loadPermaPages(currentPages, 'previewpages', `/api/items/preview-pages`, o)
                } else {
                    //real deal book!!
                    let o = {}
                    o["id"] = issueObject.id;
                    o["wallet"] = address.address;
                    o["publickey"] = publicKeyRef.current;
                    //loadPermaPages(currentPages, 'book', `/api/nft-list-items/book-pages`, o)
                }
                break
            default:
                console.error('Unsupported file extension')
                dispatch(setError('Unsupported file extension'));
                //dispatch(setHome(true));
                return
        }

    }

    /*

    PERMA

    */


    // const loadPermaPages = async (pageNum, permaType, rest, o) => {
    //     if (windowResizing) { return }
    //     if (loadingTask.current) { return }

    //     setCurrentPermaType(permaType);

    //     if (executeRecaptcha) {
    //         try {
    //             const { callProtectedApi } = makeProtectedRequest(executeRecaptcha);
    //             let urlsPromises;

    //             pageNum = returnPageNum(pageNum);

    //             urlsPromises = pageNum
    //                 .filter(page => page > 0 && page <= numPages)
    //                 .map(page => {
    //                     let oCopy = { ...o, "pages": page };
    //                     return callProtectedApi(
    //                         rest,
    //                         oCopy,
    //                         'POST',
    //                         permaType,
    //                         'arraybuffer' // Set the response type as array buffer
    //                     ).then(async response => {
    //                         const serverPublicKey = response.headers['x-server-public-key'];
    //                         const sharedSecret = await dhAES.current.computeSharedSecret(serverPublicKey); 

    //                         // Decrypt the image
    //                         const decryptedData = await dhAES.current.aesDecrypt(new Uint8Array(response.data), sharedSecret);
    //                         const contentType = response.headers['content-type'];
    //                         return new Blob([decryptedData], { type: contentType });

    //                         // const contentType = response.headers['content-type'];
    //                         // return new Blob([response.data], { type: contentType });

    //                     })
    //                 });


    //             Promise.all(urlsPromises).then(urls => {
    //                 //console.log("Rendering")
    //                 renderPermaPages(pageNum, urls);
    //             });


    //         } catch (error) {
    //             console.error('An error occurred:', error);
    //             dispatch(setError(error.message));
    //             dispatch(setHome(true));
    //         }
    //      }
    // };


    // const renderPermaPages = async (pageNum, blobs) => {
    //     if (windowResizing || !blobs || loadingTask.current) {
    //         return;
    //     }

    //     loadingTask.current = true;

    //     if (!working) {
    //         setWorkingStore(true);
    //     }

    //     pageNum = returnPageNum(pageNum)

    //     let pv = issuePageViewObject()


    //     try {
    //         gsap.set(getCurrentCanvasContainer(), { opacity: 0 });

    //         /* eslint-disable no-loop-func */
    //         for (let i = 0; i < pageNum.length; i++) {
    //             const curPageNum = pageNum[i];
    //             if (pagesRendering[i]) continue;
    //             pagesRendering[i] = true;

    //             const blob = blobs[i];

    //             if (!blob) continue;
    //             if (!working) setWorkingStore(true);

    //             const imgBitmap = await createImageBitmap(blob);


    //             const canvas = document.createElement('canvas');
    //             document.getElementById('excel_holder').appendChild(canvas);

    //             const naturalWidth = imgBitmap.width;
    //             const naturalHeight = imgBitmap.height;
    //             let multiplier = portrait ? 1 : 2;

    //             let scaleWidth = (pv.width * VIEW_SCALE) / (naturalWidth * multiplier);
    //             let scaleHeight = (pv.height * VIEW_SCALE) / naturalHeight;

    //             let scale = Math.min(scaleWidth, scaleHeight);

    //             canvasholder.push(canvas);

    //             canvas.height = (pv.height * VIEW_SCALE) * 2;
    //             canvas.width = (pv.width * VIEW_SCALE) * 2;
    //             canvas["scale"] = scale;

    //             const ctx = canvas.getContext('2d');

    //             // Image rendering quality settings
    //             ctx.imageSmoothingEnabled = true;
    //             ctx.imageSmoothingQuality = 'high';
    //             ctx.mozImageSmoothingEnabled = true;
    //             ctx.webkitImageSmoothingEnabled = true;
    //             ctx.msImageSmoothingEnabled = true;

    //             if (ctx) {
    //                 ctx.scale(scale * 2 * multiplier, scale * 2 * multiplier);
    //                 ctx.clearRect(0, 0, canvas.width, canvas.height);
    //                 ctx.beginPath();
    //             }

    //             ctx.drawImage(imgBitmap, 0, 0, imgBitmap.width, imgBitmap.height);

    //             pageViews[i] = [0, 0, pv.width, pv.height];
    //             renderTasks[i] = [curPageNum, i];
    //         }

    //         for (let n = 0; n < renderTasks.length; n++) {
    //             postRenderPageCleanUp(renderTasks[n]);
    //         }
    //     } catch (error) {
    //         console.error('An error occurred while processing the file:', error);
    //         dispatch(setError('An error occurred while processing the file: ', error.message));
    //         dispatch(setHome(true));
    //     }
    // };

    /*

    ARCHIVED COMIC FILES

    */

    const renderComicFiles = async (pageNum) => {

        if (windowResizing || !pdfRef || loadingTask.current) {
            return;
        }
        loadingTask.current = true;

        if (!working) {
            setWorkingStore(true);
        }

        pageNum = returnPageNum(pageNum)

        loadingTask.current = ComicArchiveFileProcessor.current.process(pdfRef, extension, pageNum)
            .then(async (images) => {

                if (images.length === 1 && images[0] === null) {
                    await new Promise(resolve => setTimeout(resolve, 300));
                    switch (lastActionRef.current[0]) {
                        case "goNextPage":
                        case "goNextPanel":
                            goNextPage()
                            break
                        case "goPrevPage":
                        case "goPrevPanel":
                            goPrevPage()
                            break
                        case "goToPage":
                            goToPage(lastActionRef.current[1] + 1)
                            break
                        default:
                            goToPage(currentPage + 1)
                            break

                    }

                    loadingTask.current = false;
                    return;
                }

                setNumPagesStore(ComicArchiveFileProcessor.current.getTotalPages());

                gsap.set(getCurrentCanvasContainer(), { opacity: 0 });

                /* eslint-disable no-loop-func */
                for (let i = 0; i < images.length; i++) {
                    const curPageNum = pageNum[i];
                    if (pagesRendering[i]) continue;
                    pagesRendering[i] = true;

                    const imageBlob = images[i];
                    if (!imageBlob) continue;
                    if (!working) setWorkingStore(true);

                    const img = new window.Image();
                    img.src = URL.createObjectURL(imageBlob);

                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    await new Promise((resolve) => {
                        img.onload = () => {
                            const canvas = document.createElement('canvas');
                            document.getElementById('excel_holder').appendChild(canvas);

                            const naturalWidth = img.naturalWidth;
                            const naturalHeight = img.naturalHeight;
                            let multiplier = portrait ? 1 : 2;

                            let scale = Math.min((size.width / (naturalWidth * multiplier)), size.height / naturalHeight);

                            // eslint-disable-next-line react-hooks/exhaustive-deps
                            canvasholder.push(canvas);

                            canvas.height = (naturalHeight * VIEW_SCALE);
                            canvas.width = (naturalWidth * VIEW_SCALE);
                            canvas["scale"] = scale;

                            const ctx = canvas.getContext('2d');

                            // Image rendering quality settings
                            ctx.imageSmoothingEnabled = true;
                            ctx.imageSmoothingQuality = 'high';
                            ctx.mozImageSmoothingEnabled = true;
                            ctx.webkitImageSmoothingEnabled = true;
                            ctx.msImageSmoothingEnabled = true;

                            ctx.scale(VIEW_SCALE, VIEW_SCALE);

                            if (ctx) {
                                ctx.clearRect(0, 0, canvas.width, canvas.height);
                                ctx.beginPath();
                            }

                            ctx.drawImage(img, 0, 0, img.width, img.height);

                            pageViews[i] = [0, 0, img.naturalWidth, img.naturalHeight];
                            renderTasks[i] = [curPageNum, i];


                            resolve();
                        };
                    });
                }
                for (let n = 0; n < renderTasks.length; n++) {
                    postRenderPageCleanUp(renderTasks[n]);
                }

            })
            .catch((error) => {
                console.error('An error occurred while processing the file:', error);
                dispatch(setError('An error occurred while processing the file: ', error.message));
            });
    };


    /*

            PDF LOAD

    */

    const renderPDFPages = async (pageNum) => {

        if (windowResizing) { return }
        if (!pdfRef) { return }

        if (loadingTask.current) { return }
        loadingTask.current = true

        let decryptedData;
        let arrayBuffer;

        if (bookData[2] && bookData[2] !== "Unencrypted") {

            decryptedData = await decryptFile(pdfRef, JSON.stringify(bookData[2]))
            arrayBuffer = await new Response(decryptedData).arrayBuffer()

        } else {
            arrayBuffer = await new Response(pdfRef).arrayBuffer()
        }

        const uint8Array = new Uint8Array(arrayBuffer)
        loadingTask.current = pdfjsLib.current.getDocument({ data: uint8Array })


        console.log(arrayBuffer )


        loadingTask.current.promise.then(async (loadedPdf) => {

            pdf_doc = loadedPdf
            setNumPagesStore(pdf_doc.numPages)

            pageNum = returnPageNum(pageNum)

            /* eslint-disable no-loop-func */
            for (var i = 0; i < pageNum.length; i++) {

                if (!pagesRendering[i]) {

                    pagesRendering[i] = true
                    //[1-2] layer 1, [3-4] layer 2
                    whichCanvasLayer = !portrait ? (pageNum[i] % 4) + 1 : (pageNum[i] % 2) + 1

                    const curPageNum = pageNum[i]

                    if (curPageNum !== 0 && curPageNum <= pdf_doc.numPages) {

                        if (!working) { setWorkingStore(true) }

                        const my_i = i

                        //console.log(getCurrentCanvasContainer())
                        gsap.set(getCurrentCanvasContainer(), { opacity: 0 })

                        // eslint-disable-next-line react-hooks/exhaustive-deps
                        await pdf_doc.getPage(curPageNum).then(function (page) {


                            var canvas = document.createElement('canvas')

                            document.getElementById('excel_holder').appendChild(canvas)

                            let multiplier = portrait ? 1 : 2

                            // let viewport = page.getViewport({ scale: isMobile() ? .5 : 1 })
                            let viewport = page.getViewport({ scale: 1 })

                            var scale = Math.min((size.width / (viewport.width * multiplier)), size.height / viewport.height)
                            viewport = page.getViewport({ scale: scale })

                            canvasholder.push(canvas)

                            canvas.height = (viewport.height * VIEW_SCALE) * scale
                            canvas.width = (viewport.width * VIEW_SCALE) * scale

                            // canvas["viewport"] = viewport
                            canvas["scale"] = scale;


                            let ctx = canvas.getContext('2d')
                            ctx.imageSmoothingEnabled = true
                            ctx.imageSmoothingQuality = 'high'
                            ctx.mozImageSmoothingEnabled = true
                            ctx.webkitImageSmoothingEnabled = true
                            ctx.msImageSmoothingEnabled = true

                            ctx.scale(VIEW_SCALE, VIEW_SCALE);

                            if (ctx) {
                                ctx.clearRect(0, 0, canvas.width, canvas.height)
                                ctx.beginPath()
                            }

                            var transform = scale !== 1
                                ? [scale, 0, 0, scale, 0, 0]
                                : null

                            const renderContext = {
                                canvasContext: ctx,
                                background: 'rgba(0,0,0,0)',
                                viewport: viewport,
                                transform: transform
                            }



                            if (!renderTasks[my_i]) {

                                pageViews[my_i] = page.view


                                renderTasks[my_i] = page.render(renderContext)
                                renderTasks[my_i].promise.then(postRenderPageCleanUp.bind(this, [curPageNum, my_i]))


                            }


                        })
                    }
                }
            }


        })
    }


    useEffectOnceWhen(() => {

        (async () => {
            await dhAES.current.initialize();
            publicKeyRef.current = dhAES.current.publicKeyHex;
        })();

        setCanvas1([document.createElement("canvas"), canvas1[1], canvas1[2]])
        setCanvas2([document.createElement("canvas"), canvas2[1], canvas2[2]])

        swapCanvasLayers()

        if (layerRef1.current) {
            layerRef1.current.dragBoundFunc((pos) => {
                updateCompanionLayer(layerRef1.current, layerRef2.current)
                return pos
            })
        }

        if (layerRef2.current) {
            layerRef2.current.dragBoundFunc((pos) => {
                updateCompanionLayer(layerRef2.current, layerRef1.current)
                return pos
            })
        }

        timeoutRef.current = setTimeout(handleError, 120000); // 120 seconds


    }, [])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!Boolean(address) && currentPermaType === 'book') {
            dispatch(setError("Your wallet is disconnected. Please connect your wallet to view this book."));
            dispatch(setHome(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, currentPermaType]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        setAnimatingStore(animTweenRef.current !== null && animTweenRef.current.isActive());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [animTweenRef.current]);

    // This effect runs whenever 'working' changes, AND THROWS AN ERROR after 15 seconds
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (working) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(handleError, 120000); // 120 seconds
        } else {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [working]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (working && !animating) {
            dispatch(setLoading(true))
        } else if (!working) {
            dispatch(setReading())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [working, animating])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {

        if (!extension) { return }

        if (currentPages[0] !== currentPage && currentPages[1] !== currentPage) {
            syncCurrentPageStates()
            return
        }

        let doRerender = (mode === 'focus' && !portrait ? false : previousPage !== currentPage) || JSON.stringify(previousPages) !== JSON.stringify(currentPages)

        setPreviousPages(previousPages => currentPages)
        setPreviousPage(previousPage => currentPage)
        //removed !inited since redux rehydration was breaking it for some reason... 
        //if(getWindowResized() || doRerender || !inited){
        if (getWindowResized() || doRerender) {

            renderBasedOnExtension()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pdfRef, currentPages, renderBasedOnExtension])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!currentAction || currentAction[0] === "") { return }
        lastActionRef.current = currentAction
        switch (currentAction[0]) {
            case "goNextPage":
                goNextPage()
                break
            case "goNextPanel":
                goNextPanel()
                break
            case "goPrevPage":
                goPrevPage()
                break
            case "goPrevPanel":
                goPrevPanel()
                break
            case "goToPage":
                goToPage(currentAction[1])
                break
            default:
                break
        }
        setCurrentActionStore(["", 0])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentAction])



    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!inited) { return }

        //Keep up with changed properties

        //ZOOM
        if ((zoomed !== previousZoomed || ZOOM_MAX !== previousZoomMax) && mode === 'classic') {
            setPreviousZoomed(previousZoomed => zoomed)
            setPreviousZoomMax(previousZoomMax => ZOOM_MAX)
            zoomPage()
        }
        //MODES
        if (mode === "classic" || mode === "build") {
            if (previousMode !== mode) {
                zoomPage()
                if (mode === "build") {
                    setZoomedStore(false)
                    renderBasedOnExtension()
                } else if (previousMode === 'build') {
                    renderBasedOnExtension()
                }

            }
        } else if (mode === "focus") {
            //In focus mode, set zoom to FALSE!!!!
            if (previousMode !== mode) {
                setZoomedStore(false)
                fastResetCanvasZoom()
                moveToNextPanel()
            }

        }
        document.body.style.cursor = "default"
        setPreviousMode(previousMode => mode)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, zoomed, ZOOM_MAX, inited])



    useEffect(() => {
        if (!inited) { return }
        if (working) { return }
        if (mode !== 'focus') { return }

        if (previousPanel !== currentPanel) {
            if (previousPanel < currentPanel) {
                //we are moving ahead
                if (currentPanel > totalPanels()) {
                    //GO NEXT PAGE
                    //console.log("GO NEXT PAGE ")
                    if (currentPages[1] > numPages || currentPage + 1 > numPages) {
                        //REACHED THE END
                        setModeStore('classic')
                        setCurrentPanelStore(currentPanel - 1)
                        return
                    }

                    setCurrentPanelStore(1)
                    setPreviousPanel(previousPanel => 1)

                    setWorkingStore(true)
                    setCurrentActionStore(["goNextPage", null])

                } else {
                    //SAME PAGE
                    //console.log("SAME PAGE> ", currentPanel)  
                    moveToNextPanel()
                    setPreviousPanel(previousPanel => currentPanel)
                }
            } else {
                //we are moving back
                if (currentPanel < 1) {
                    //GO PREV PAGE
                    //console.log("GO PREV PAGE ", totalPanelsPreviousPage())
                    if (currentPages[0] < 1 || currentPage - 1 < 1) {
                        setCurrentPanelStore(currentPanel + 1)
                        return
                    }

                    setCurrentPanelStore(totalPanelsPreviousPage())
                    setPreviousPanel(previousPanel => totalPanelsPreviousPage())

                    setWorkingStore(true)
                    setCurrentActionStore(["goPrevPage", null])
                } else {
                    //SAME PAGE
                    //console.log("<SAME PAGE ", currentPanel)
                    moveToNextPanel()
                    setPreviousPanel(previousPanel => currentPanel)
                }
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPanel])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        //Refill current pages array with correct pages
        syncCurrentPageStates()
        swapCanvasLayers()

        //May be breaking change!!!
        if (mode === 'focus' && previousPage !== currentPage && working && inited && !portrait) {
            if (currentPage === currentPages[0] || currentPage === currentPages[1]) {
                moveToNextPanel(
                    previousPage < currentPage && currentPage % 2 === 0 ?
                        true
                        :
                        previousPage > currentPage && currentPage % 2 === 1 ?
                            true :
                            false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage])

    useEffect(() => {
        if (imageRef1.current) {
            imageRef1.current.image(canvas1[0])
            imageRef1.current.cache({
                key: "imageRef1"
            })
            imageRef1.current.draw()

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canvas1])

    useEffect(() => {
        if (imageRef2.current) {
            imageRef2.current.image(canvas2[0])
            imageRef2.current.cache({
                key: "imageRef2"
            })
            imageRef2.current.draw()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canvas2])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {

        clearContexts(getOldCanvasLayer()[0])
        clearContexts(getCurrentCanvasLayer()[0])

        resetClippedGroups()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [size])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (working) {
            if (!pdfRef) {
                return;
            }

            swapCanvasLayers();

            const onCompleteAnimation = () => {
                setInitied(true);
                setWorkingStore(false);
            };


            gsap.to(getCurrentCanvasContainer(), {
                delay: 1.25,
                opacity: 1,
                duration: 0.5,
            });
            gsap.to(getOldCanvasContainer(), {
                delay: 1.25,
                opacity: 0,
                onComplete: () => {
                    unloadCanvasLayer();
                    onCompleteAnimation(); // Call the function after the animation completes
                },
                duration: 0.5,
            });

            if (mode === 'focus') {
                moveToNextPanel(true, false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canvas1, canvas2]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {

        //Check for uploaded book!

        const initPDFData = async () => {
            if (!loadingTask.current && (bookData[0] && bookData[1] && bookData[2])) {


                setExtention(bookData[3])
                setIssueObjectStore(bookData[1])
                setPdfRef(bookData[0])

            }
        }

        initPDFData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookData])



    




    /*

               END USE EFFECTS

     */


    /*

          ERROR HANDLING

      */

    const handleError = () => {
        dispatch(setError('Uh oh. Something went wrong. You\'ll be taken back to the home screen in a few seconds.'));
        setTimeout(() => {
            dispatch(setHome(true));
        }, 5000); // 5 seconds
        // throw new Error('Uh oh. Something went wrong.');
    }

    /*

         HANLDERS

     */

    const handleCanvasDoubleClick = (e) => {
        // Code for double click event
        //console.log("Double click detected")
        // console.log("double click")
        if (mode === "classic") {
            setZoomedStore(!zoomed)
            setZoomedPositionStore({ x: e.evt.offsetX, y: e.evt.offsetY })
        } else if (mode === 'focus') {
            setModeStore('classic')

        }
    }

    const handleCanvasClick = (e) => {
        //e.evt.stopPropagation()
        // console.log("Click");
        if (lastClick.current !== null && Date.now() - lastClick.current < 300) {
            handleCanvasDoubleClick(e);
            lastClick.current = null;
        } else {
            lastClick.current = Date.now();
            setTimeout(() => {
                if (lastClick.current === Date.now()) {
                    // Code for single click event
                    //console.log("Single click detected");
                }
            }, 300);
        }
    };


    const syncCurrentPageStates = () => {
        if (!pdfRef) { return }
        var pos = currentPage % 2
        var ary = [0, 0]
        ary[pos] = currentPage
        ary[pos === 0 ? 1 : 0] = (pos === 0 ?
            (currentPage + 1) > numPages ? 0 : currentPage + 1
            :
            (currentPage - 1) < 0 ? 0 : currentPage - 1
        )
        // console.log("currentPages ",currentPages)
        // console.log("ary ",ary)
        setCurrentPagesStore(ary)
    }

    const postRenderPageCleanUp = async (props) => {
        if (!props || props[1] === undefined) {
            return;
        }
        //props[0] is current page num
        //props[1] is current position in arrays
        pagesRendering[props[1]] = false

        if (renderTasks[0] === null || renderTasks[1] === null) {

            let canvobj = getCurrentCanvasLayer()[0]
            let ctx = canvobj.getContext('2d', { antialias: true, willReadFrequently: true })

            canvobj.style.cssText = 'image-rendering: optimizeSpeed;' + // FireFox < 6.0
                'image-rendering: -moz-crisp-edges;' + // FireFox
                'image-rendering: -o-crisp-edges;' +  // Opera
                'image-rendering: -webkit-crisp-edges;' + // Chrome
                'image-rendering: crisp-edges;' + // Chrome
                'image-rendering: -webkit-optimize-contrast;' + // Safari
                'image-rendering: pixelated; ' + // Future browsers
                '-ms-interpolation-mode: nearest-neighbor;' // IE


            let scale = canvasholder[0].scale || 1;

            var multiplier = (canvasholder.length > 1 ? 2 : 1)


            canvobj.height = (canvasholder[0].height)
            canvobj.width = ((canvasholder[0].width * multiplier))

            ctx.imageSmoothingEnabled = true
            ctx.imageSmoothingQuality = 'high'
            ctx.mozImageSmoothingEnabled = true
            ctx.webkitImageSmoothingEnabled = true
            ctx.msImageSmoothingEnabled = true

            ctx.save()

            ctx.drawImage(canvasholder[0], 0, 0, canvasholder[0].width, canvasholder[0].height)

            if (canvasholder.length > 1) {
                ctx.drawImage(canvasholder[1], canvasholder[1].width, 0, canvasholder[1].width, canvasholder[1].height)

            }

            ctx.restore()

            var canvasScale = Math.min((size.width / canvobj.width), size.height / canvobj.height)
            setCurrentCanvasLayerWith(canvobj, canvobj.width, canvobj.height,
                pageViews[0] ?
                    pageViews[0][2] + (canvasholder.length > 1 ? pageViews[1][2] : 0)
                    :
                    pageViews[1][2]
                ,
                pageViews[0] ?
                    pageViews[0][3] :
                    pageViews[1][3],
                scale,
                canvasScale)

            clearContexts(canvasholder[0])
            document.getElementById('excel_holder').removeChild(canvasholder[0])

            if (canvasholder.length > 1) {
                clearContexts(canvasholder[1])
                document.getElementById('excel_holder').removeChild(canvasholder[1])
            }



            canvasholder = []

            if (zoomed) {
                updateCompanionLayer(getOldCanvasContainer(), getCurrentCanvasContainer())
            }
            loadingTask.current = null

            if (pdf_doc) {
                pdf_doc.destroy()
                pdf_doc = null
            }

        }
        renderTasks[props[1]] = null
    }



    const getOldCanvasLayer = () => {
        //[1-2] canvas2 is old!, [3-4] canvas1 is old!
        return returnWhichCanvasLayerEval() ? canvas1 : canvas2
    }
    const getCurrentCanvasLayer = () => {
        //[1-2] canvas1 is CURRENT!, [3-4] canvas2 is CURRENT!
        return returnWhichCanvasLayerEval() ? canvas2 : canvas1
    }

    const setCurrentCanvasLayerWith = (_o, _w, _h, _nw, _nh, _os, _cs) => {
        //[1-2] set current Canvas1, [3-4] set current Canvas2
        returnWhichCanvasLayerEval() ? setCanvas2([_o, { w: _w, h: _h, naturalWidth: _nw, naturalHeight: _nh, origScale: _os, canvasScale: _cs }, Date.now()]) : setCanvas1([_o, { w: _w, h: _h, naturalWidth: _nw, naturalHeight: _nh, origScale: _os, canvasScale: _cs }, Date.now()])
    }
    const getOldCanvasContainer = () => {
        return returnWhichCanvasLayerEval() ? layerRef1.current : layerRef2.current
    }
    const getCurrentCanvasContainer = () => {
        //[1-2] canvas 1 and layerref 1, [3-4] canvas 2 and layerref 2
        return returnWhichCanvasLayerEval() ? layerRef2.current : layerRef1.current
    }

    const getCurrentImageRef = () => {

        return returnWhichCanvasLayerEval() ? imageRef2 : imageRef1
    }
    const getOldLayerGroup = () => {
        return returnWhichCanvasLayerEval() ? groupRef1.current : groupRef2.current
    }
    const getCurrentLayerGroup = () => {
        return returnWhichCanvasLayerEval() ? groupRef2.current : groupRef1.current
    }

    const returnWhichCanvasLayerEval = () => {
        if (!whichCanvasLayer) {
            whichCanvasLayer = !portrait ? (currentPage % 4) + 1 : (currentPage % 2) + 1
        }
        return whichCanvasLayer >= (!portrait ? 3 : 2)
    }

    const returnPageNum = (pageNum) => {
        return (portrait || mode === 'build') ? [currentPage] : pageNum
    }

    const swapCanvasLayers = () => {
        //mod 4 remainder for current page is based on 0-1 goes to layer 1, 2-3 goes to layer 2
        //Written below it's easier to +1, but it's not necessary. We're grouping pages as [0-1,2-3] so it's easier to briefly read them visually as [1-2][3-4] in the sequence.

        if (!portrait ? (currentPage % 4) + 1 >= 3 : (currentPage % 2) + 1 >= 2) {
            setLayerOneZIndex(layerOneZIndex => 5)
            setLayerTwoZIndex(layerTwoZIndex => 6)
        } else {
            setLayerOneZIndex(layerOneZIndex => 6)
            setLayerTwoZIndex(layerTwoZIndex => 5)
        }

    }
    const unloadCanvasLayer = () => {
        resetDraggedElements()
        let canvobj = getOldCanvasLayer()[0]

        clearContexts(canvobj)

        resetClippedGroup(getOldLayerGroup())

        if (mode === 'focus') {
            moveToNextPanel()
        }
    }
    function goNextPage() {
        if (mode !== 'focus') { setCurrentPanelStore(1) }

        if (!portrait && mode !== 'focus') {
            //LANDSCAPE
            //console.log("Setting current pages to ", [currentPages[1] + 1, currentPages[1] + 2])
            setCurrentPagesStore([currentPages[1] + 1, currentPages[1] + 2])
            setCurrentPageStore(currentPages[1] + 1 > numPages ? numPages : currentPages[1] + 1)
        } else {
            //PORTRAIT || FOCUS
            setCurrentPageStore(currentPage + 1 > numPages ? numPages : currentPage + 1)
        }

    }

    function goPrevPage() {
        if (mode !== 'focus') { setCurrentPanelStore(1) }

        if (!portrait && mode !== 'focus') {
            //LANDSCAPE
            setCurrentPagesStore([currentPages[0] - 2, currentPages[0] - 1])
            setCurrentPageStore(currentPages[0] - 2 < 1 ? 1 : currentPages[0] - 2)
        } else {
            //PORTRAIT || FOCUS
            setCurrentPageStore(currentPage - 1 < 1 ? 1 : currentPage - 1)

        }


    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const goNextPanel = useCallback(() => {
        if (working) { return }
        if (animTweenRef.current && animTweenRef.current.isActive()) {
            return;
        }
        setCurrentPanelStore(currentPanel + 1)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [animTweenRef, currentPanel, working])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const goPrevPanel = useCallback(() => {
        if (working) { return }
        if (animTweenRef.current && animTweenRef.current.isActive()) {
            return;
        }
        setCurrentPanelStore(currentPanel - 1)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [animTweenRef, currentPanel, working])

    function goToPage(page) {
        if (!pdfRef) { return }
        //swapCanvasLayers()
        setCurrentPageStore(page)
        setPreviousPage(9999999999)
        setCurrentPanelStore(1)

    }


    function resetClippedGroups() {
        resetClippedGroup(groupRef1.current)
        resetClippedGroup(groupRef2.current)
    }
    function resetClippedGroup(which) {
        gsap.set(which, {
            scaleX: 1,
            scaleY: 1,
            x: 0,
            y: 0,
            clipX: 1,
            clipY: 1,
            clipWidth: size.width,
            clipHeight: size.height

        })
    }
    function resetDraggedElements() {

        var groupEl = getCurrentLayerGroup()

        var imageRef = getCurrentImageRef()
        if (!imageRef.current) { return }
        var imgRect = imageRef.current.getClientRect()

        if (groupEl.attrs.x) {
            //Correct for group transform
            imgRect.x -= groupEl.attrs.x
            imgRect.y -= groupEl.attrs.y
            imgRect.x /= groupEl.attrs.scaleX
            imgRect.y /= groupEl.attrs.scaleX
            imgRect.width /= groupEl.attrs.scaleX
            imgRect.height /= groupEl.attrs.scaleX
        }


        const scaler = (zoomed ? ZOOM_MAX : ZOOM_MIN)
        const newX = zoomedPosition.x * (scaler - 1)
        const newY = zoomedPosition.y * (scaler - 1)


        gsap.to([layerRef1.current, layerRef2.current], {
            x: zoomedPosition.x && zoomed ? zoomedPosition.x > 0 ? -1 * newX : 0 : 0,
            y: zoomedPosition.y && zoomed ? zoomedPosition.y > 0 ? -1 * newY : 0 : 0,
            ease: "easer.Inout",
            duration: TRANSITION_SPEED,
            delay: 0.1,
        })



        setZoomedPositionStore({ x: 0, y: 0 })
    }
    const clearContexts = (c) => {
        if (!c) { return }
        let ctx = c?.getContext('2d')
        if (ctx) {
            ctx?.resetTransform()
            ctx?.clearRect(-10, -10, c.width + 10, c.height + 10)
            ctx?.beginPath()
            ctx?.save();
        }

        if (imageRef1?.current) {
            imageRef1?.current?.cache()
        }
        if (imageRef2?.current) {
            imageRef2?.current?.cache()
        }

    }






    return (
        <>



            {/* <div id="excel_div_main" className={`excel_div_main ${mode==='focus' ? "gradient_off" : ""}`}>

                <div style={{position: 'relative', display: !focusProtection ? 'none' : 'block'}}> */}

            <div id="excel_div_main" className={`excel_div_main ${mode === 'focus' ? "gradient_off" : ""}`}>
                <div style={{ position: 'relative', display: !focusProtection ? 'none' : 'block' }}>

                    <div ref={stageDivRef1}
                        style={{
                            position: 'absolute',
                            zIndex: layerOneZIndex,
                        }}

                    >

                        <Shake>


                            <Stage
                                width={size.width}
                                height={size.height}
                            >

                                <Layer ref={layerRef1}
                                    className="excel_div_canvas excel_inner"
                                    draggable={zoomed}
//                                     dragBoundFunc={(pos) => {
//     let newX = isMobile() ? pos.x * 3 : pos.x;
//     let newY = isMobile() ? pos.y * 3 : pos.y;

//     // Get the scale of the image
//     let scaleX = canvas1[1].canvasScale;
//     let scaleY = canvas1[1].canvasScale;

//     // Calculate the scaled dimensions of the image
//     let scaledWidth = canvas1[1].w * scaleX;
//     let scaledHeight = canvas1[1].h * scaleY;

//     // Limit the draggable area to the scaled dimensions of the image
//     newX = Math.max(Math.min(newX, size.width - scaledWidth), -scaledWidth);
//     newY = Math.max(Math.min(newY, size.height - scaledHeight), -scaledHeight);

//     // Adjust for mobile
//     if (isMobile()) {
//         newX += size.width;
//         newY += size.height;
//     }

//     return {
//         x: newX,
//         y: newY
//     }
// }}
                                >
                                    <Group ref={groupRef1} >


                                        {canvas1[1].w > 0 &&
                                            <>

                                                <Image
                                                    key={canvas1[2]}
                                                    ref={imageRef1}
                                                    source={canvas1[0]}

                                                    x={size.width / 2}
                                                    y={size.height / 2}
                                                    offsetX={+canvas1[1].w / 2}
                                                    offsetY={+canvas1[1].h / 2}
                                                    scaleY={canvas1[1].canvasScale}
                                                    scaleX={canvas1[1].canvasScale}

                                                    onClick={(e) => {

                                                        handleCanvasClick(e)
                                                    }}
                                                />


                                                {mode === "build" &&
                                                    <ExcelsiorRect groupRef={groupRef1}
                                                        imageRef={imageRef1}
                                                        origScale={canvas1[1].origScale}
                                                        naturalWidth={canvas1[1].naturalWidth}
                                                        naturalHeight={canvas1[1].naturalHeight} />
                                                }


                                            </>
                                        }


                                    </Group>

                                </Layer>



                            </Stage>
                        </Shake>

                    </div>

                    <div ref={stageDivRef2}
                        style={{
                            position: 'absolute',
                            zIndex: layerTwoZIndex,
                        }}

                    >

                        <Shake>
                            <Stage width={size.width} height={size.height} >
                                <Layer ref={layerRef2}
                                    className="excel_div_canvas excel_inner"
                                    draggable={zoomed}
//                                     dragBoundFunc={(pos) => {
//     let newX = isMobile() ? pos.x * 3 : pos.x;
//     let newY = isMobile() ? pos.y * 3 : pos.y;

//     // Get the scale of the image
//     let scaleX = canvas2[1].canvasScale;
//     let scaleY = canvas2[1].canvasScale;

//     // Calculate the scaled dimensions of the image
//     let scaledWidth = canvas2[1].w * scaleX;
//     let scaledHeight = canvas2[1].h * scaleY;

//     // Limit the draggable area to the scaled dimensions of the image
//     newX = Math.max(Math.min(newX, size.width - scaledWidth), -scaledWidth);
//     newY = Math.max(Math.min(newY, size.height - scaledHeight), -scaledHeight);

//     // Adjust for mobile
//     if (isMobile()) {
//         newX += size.width;
//         newY += size.height;
//     }

//     return {
//         x: newX,
//         y: newY
//     }
// }}

                                >
                                    <Group ref={groupRef2}>

                                        {canvas2[1].w > 0 &&
                                            <>

                                                <Image
                                                    key={canvas2[2]}
                                                    ref={imageRef2}
                                                    source={canvas2[0]}

                                                    x={size.width / 2}
                                                    y={size.height / 2}
                                                    offsetX={+canvas2[1].w / 2}
                                                    offsetY={+canvas2[1].h / 2}
                                                    scaleY={canvas2[1].canvasScale}
                                                    scaleX={canvas2[1].canvasScale}

                                                    onClick={(e) => {
                                                        handleCanvasClick(e)
                                                    }}

                                                />


                                                {mode === "build" &&
                                                    <ExcelsiorRect groupRef={groupRef2}
                                                        imageRef={imageRef2}
                                                        origScale={canvas2[1].origScale}
                                                        naturalWidth={canvas2[1].naturalWidth}
                                                        naturalHeight={canvas2[1].naturalHeight} />
                                                }

                                            </>
                                        }

                                    </Group>
                                </Layer>
                            </Stage>
                        </Shake>

                    </div>





                </div>

                <BetaDisclaimer perma={currentPermaType} />

                {!inited &&
                    <Box
                        className="excel_svg_line"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        position="fixed"
                        top={0}
                        left={0}
                        width="100%"
                        height="100%"
                        zIndex={99999}
                    >
                        <Loader />
                    </Box>
                }


                {inited &&
                    <div style={{ display: (!focusProtection || valueProtection > 0) ? "block" : "none", pointerEvents: 'none' }}>

                        <Box className={(!focusProtection || valueProtection > 0) ? (valueProtection > 1 ? "excel_protective_show" : "excel_protective_show_fade") : "excel_protective_hide"} >



                            <CustomAlert severity="info" title="Did you know?" style={{ pointerEvents: "none" }}>
                                This app cannot operate while certain keyboard keys are depressed. If you're seeing this screen even though none of your keyboard keys are currently depressed, please press and release the SHIFT key once to clear the screen. If that doesn't work, please refresh your browser. Happy reading!
                            </CustomAlert>


                        </Box>


                    </div>

                }
            </div>

            <div>
                <div id="excel_holder" style={{ pointerEvents: "none", display: "none", position: "absolute", top: "-9999px", left: "-9999px" }}></div>
            </div>

            <ArrowAlert />


        </>
    )
}

export const ExcelsiorPageViewer = React.memo(ExcelsiorPageViewerFunc)